// Classes
import { ProspectProfileReducerState } from "Containers/Filter/ProspectProfile/classes/prospectProfile.classes";
import { AttributeObject } from "../classes/attributes.classes";

/**
 * @function getIntendedMajorAttributes
 *
 * Post-processes the attributes for this section of the filter
 *
 * @param {ProspectProfileReducerState} prospectProfile - The current state
 * of the Prospect Profile filter section.
 * @return {AttributeObject | undefined}
 *
 * @example
 *
 *     getIntendedMajorAttributes(prospectProfile)
 */
export const getIntendedMajorAttributes = (
  prospectProfile: ProspectProfileReducerState
) => {
  let attributeArray: any[] = [];

  prospectProfile.intendedMajor.forEach((major: any) => {
    attributeArray.push(major.label);
  });

  let attributeObject: any;

  if (attributeArray.length > 0) {
    attributeObject = new AttributeObject(
      (attributeArray.length > 1 && `Major=${attributeArray.length}`) ||
        attributeArray[0],
      "standard",
      attributeArray.length > 1 && attributeArray
    );
  } else {
    attributeObject = undefined;
  }

  return attributeObject;
};
try {
    // @ts-ignore
    getIntendedMajorAttributes.displayName = "getIntendedMajorAttributes";
    // @ts-ignore
    getIntendedMajorAttributes.__docgenInfo = { "description": "", "displayName": "getIntendedMajorAttributes", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/Attributes/utilities/getIntendedMajorAttributes.ts#getIntendedMajorAttributes"] = { docgenInfo: getIntendedMajorAttributes.__docgenInfo, name: "getIntendedMajorAttributes", path: "src/shared/containers/Attributes/utilities/getIntendedMajorAttributes.ts#getIntendedMajorAttributes" };
}
catch (__react_docgen_typescript_loader_error) { }